// startup
// Load entry module and return exports
// This entry module is referenced by other modules so it can't be inlined
__webpack_require__("./node_modules/react/index.js");
__webpack_require__("./node_modules/react-dom/index.js");
__webpack_require__("./node_modules/core-js/index.js");
__webpack_require__("./node_modules/@fluentui/react-components/lib/index.js");
var __webpack_exports__ = __webpack_require__("./node_modules/@fluentui/react-icons/lib/index.js");
